import ClosedMenuIcon   from './ClosedMenuIcon';
import WorkflowIcon     from './WorkflowIcon';
import DataContextIcon  from './DataContextIcon';
import DataProviderIcon from './DataProviderIcon';
import ModelIcon from './ModelIcon';
import ParameterTableIcon from './ParameterTableIcon';
import DepsIcon from './DepsIcon';
import CloseIcon from './CloseIcon';
import SignalIcon from './SignalIcon';
import ComponentIcon from './ComponentIcon';
import PackageIcon from './PackageIcon';

export default {
  'closedMenuIcon':  ClosedMenuIcon,
  'Workflow':    WorkflowIcon,
  'DataContext': DataContextIcon,
  'DataProvider':  DataProviderIcon,
  'Model': ModelIcon,
  'ParametersTable': ParameterTableIcon,
  'DepsIcon': DepsIcon,
  'CloseIcon': CloseIcon,
  'Signal': SignalIcon,
  'Component': ComponentIcon,
  'Package': PackageIcon
};
